module.exports = __webpack_public_path__ + "static/cat_1-bec9d296533e801cb24fc8281f64720c.png";